import { PaymentMethod } from '@optiflow/types';

/** Tenders traced by a reference from the card terminal or the bank: the counter asks for one when taking them, and a refund to them names one too. Cash, a wallet or anything else needs none. */
export const METHODS_WITH_REFERENCE: readonly PaymentMethod[] = [
  PaymentMethod.CARD,
  PaymentMethod.BANK_TRANSFER,
  PaymentMethod.INSTAPAY,
];

export function methodNeedsReference(method: PaymentMethod): boolean {
  return METHODS_WITH_REFERENCE.includes(method);
}
